export const PRODUCTS_LIST = Object.freeze({
  AMERICAN_BOX: 'american-box',
  PUNCHED_BOX: 'punched-box',
  COAT_HANGER_BOX: 'coat-hanger-box',
  LITOGRAPHED_BOX: 'litographed-box',
  BOTTLE_BOX: 'bottle-box',
  EXPOSITOR: 'expositor',
  CORRUGATED_PAPER: 'corrugated-paper',
  CORNER: 'corner',
  ALVEOLAR: 'alveolar'
})
